__turbopack_context__.v({
  "card": "AiInRecruitingWhyChooseSection-module__hKYzxW__card",
  "cardTitle": "AiInRecruitingWhyChooseSection-module__hKYzxW__cardTitle",
  "iconCircle": "AiInRecruitingWhyChooseSection-module__hKYzxW__iconCircle",
  "sectionSubtitle": "AiInRecruitingWhyChooseSection-module__hKYzxW__sectionSubtitle",
  "sectionTitle": "AiInRecruitingWhyChooseSection-module__hKYzxW__sectionTitle",
  "whyChooseSection": "AiInRecruitingWhyChooseSection-module__hKYzxW__whyChooseSection",
});
